import { HttpErrorResponse } from '@angular/common/http';

// Server text only for 4xx (a 5xx can carry raw Firestore/driver detail); validation arrays are joined.
export const serverErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof HttpErrorResponse) || error.status < 400 || error.status >= 500) {
    return fallback;
  }
  const message: unknown = error.error?.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }
  if (Array.isArray(message)) {
    const parts = message.filter((part) => typeof part === 'string' && part.trim());
    if (parts.length) {
      return parts.join('; ');
    }
  }
  return fallback;
};
